export default {"src":"/_next/static/media/coin-fill.5a018f6e.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};